import styles from "../styles/LoginBody.module.scss";
import DanceIcon from "../../../public/assets/dance-icon.svg";
import LoginForm from "./LoginForm";

export default function LoginBody({
  username,
  password,
  handleUsername,
  handlePassword,
  login,
}: {
  username: string;
  password: string;
  handleUsername: (event) => void;
  handlePassword: (event) => void;
  login: () => void;
}) {
  return (
    <div className={styles.main}>
      <div className={styles.left_container}>
        <div className={styles.title}>
          <span className={styles.orange_text}>Welcome to </span>
          <span className={styles.dark_blue_text}>Harty</span>
        </div>
        <DanceIcon />
      </div>
      <LoginForm
        username={username}
        password={password}
        handleUsername={handleUsername}
        handlePassword={handlePassword}
        login={login}
      />
    </div>
  );
}
